import Table from "./Table";
export { default as ClientTable } from "./ClientTable";
export { type TableColumnOrderDirection, type TableColumnType } from "./types";

export default Table;
